module.exports = __webpack_public_path__ + "img/Carmen Rios.b92136fd.jpg";